module.exports = __webpack_public_path__ + "static/media/company-profile.da594c52.jpg";